import type { AppLocale } from '../types'
import { enMessages } from './en'
import { esMessages, type Messages } from './es'

const CATALOG: Record<AppLocale, Messages> = {
  es: esMessages,
  en: enMessages,
}

export function getMessages(locale: AppLocale): Messages {
  return CATALOG[locale]
}

export type { Messages }
